import { render, staticRenderFns } from "./AnexarLaudoExterno.vue?vue&type=template&id=3eeb50bc&"
import script from "./AnexarLaudoExterno.vue?vue&type=script&lang=js&"
export * from "./AnexarLaudoExterno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports